"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssetsForOwnerBase = void 0;
const Entities_1 = require("../../Entities");
class GetAssetsForOwnerBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.ownerID || !castPayload.callback) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'GET_ASSET_FOR_OWNER';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { ownerID, callback } = this.castPayloadV1(payload);
                this.action(ownerID, callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.GetAssetsForOwnerBase = GetAssetsForOwnerBase;
